module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_melanistic.6bc6de58.png";